
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/why-nft-storage",
      function () {
        return require("private-next-pages/docs/why-nft-storage.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/why-nft-storage"])
      });
    }
  